export const iconFontAwesomeCodingWindowRestore = (
	<i className="fa-solid fa-window-restore"></i>
);
